import React, { Component } from "react";
import { Fab } from "@mui/material";

import "./BackToTopButton.styl";
import { ArrowUpward } from "@mui/icons-material";

class BackToTopButton extends Component {
    state = { visible: false }

    static minimumScrollY = 400;

    componentDidMount() {
        if (window.addEventListener) {
            window.addEventListener("scroll", this.scrollListener);
        } else {
            window.onscroll = this.scrollListener;
        }
        this.scrollListener();
    }

    componentWillUnmount() {
        if (window.addEventListener) {
            window.removeEventListener("scroll", this.scrollListener);
        } else {
            window.onscroll = undefined;
        }
    }

    scrollListener = () => {
        if ((window.pageYOffset || document.documentElement.scrollTop) > BackToTopButton.minimumScrollY) {
            this.setState({ visible: true });
        } else {
            this.setState({ visible: false });
        }
    }
    
    getClassName = () => {
        if (this.state.visible) {
            return "BackToTopButton visible";
        }
        return "BackToTopButton";
    }

    backToTop = () => {
        if (window.scrollTo) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            document.documentElement.scrollTop = 0;
        }
    }

    render() {
        return (
            <Fab variant="extended" onClick={this.backToTop} className={this.getClassName()}>
                <ArrowUpward className="icon" />
                {this.props.children}
            </Fab>
        );
    }
}

export default BackToTopButton;